import useInputChange from "hooks/useInputChange";
import { FormEvent, useEffect } from "react";
import { IServicePlan, ServicePlanCreate } from "types/subscription.interface";

interface Props {
  onSubmit: (data: ServicePlanCreate) => void;
  onCancel: () => void;
  data?: IServicePlan;
  isLoading?: boolean;
}
export default function ServicePlanForm({
  onSubmit,
  data,
  isLoading,
  onCancel,
}: Props) {
  const { state, onChange, setState } = useInputChange<ServicePlanCreate>({
    name: "",
    interval: 0,
    price: 0,
  });

  useEffect(() => {
    if (data) setState(data);
  }, [data]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    onSubmit(state);
  };

  return (
    <form action="#!" onSubmit={handleSubmit} key={JSON.stringify(data)}>
      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">Name</label>
        <input
          type="text"
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="Premium"
          name="name"
          onChange={onChange}
          value={state.name}
        />
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">
          Interval
        </label>
        <select
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          name="interval"
          onChange={onChange}
          value={state.interval}
        >
          <option value="1">Daily (1day)</option>
          <option value="7">Weekly (7 Days)</option>
          <option value="30">Monthly (30 Days)</option>
          <option value="365">Yearly (365 Days)</option>
        </select>
      </div>

      <div className="mb-3">
        <label className="inline-block mb-2 text-base font-medium">Price</label>
        <input
          className="w-full px-3 py-2 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent placeholder:text-gray-400"
          placeholder="0.00"
          name="price"
          onChange={onChange}
          value={state.price}
          pattern="[0-9]+"
        />
      </div>

      <div className="flex justify-end gap-2 mt-4">
        <button
          type="reset"
          data-modal-close="addDocuments"
          className="px-4 py-2 text-sm rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 transition-colors"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-60 transition-colors"
        >
          {isLoading ? "Loading..." : "Submit"}
        </button>
      </div>
    </form>
  );
}
